import { Component, HostListener, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, tap } from "rxjs";
import { DataLayerServiceService } from "src/app/data-layer-service.service";
import { BehaviorService } from "src/app/services/behaviour.service";
import { CartlengthService } from "src/app/services/cartlength.service";
import { CommonService } from "src/app/services/common.service";
import { LoaderModalService } from "src/app/services/loader.service";
import { UserService } from "src/app/services/user.service";
import { AppStateService } from "src/app/shared/app-state.service";
declare var $: any;

@Component({
  selector: "app-product-listing",
  templateUrl: "./product-listing.component.html",
  styleUrls: ["./product-listing.component.css"],
})
export class ProductListingComponent {
  productListing: any = [];
  loader2: boolean = false;
  productList$: Observable<any>;
  headerBannerImage: string = "";
  gradeFilter = [];
  typeString = "";
  gradeString = "";
  quantityString = "";
  categoryName: any;
  categoryList$: Observable<any>;
  sortingType: any;
  sortingElement: any;
  alphabeticSortingType: any;
  alphabeticElement: any;
  filterText = "";
  isLoader = true;
  qtyValue = 1;
  productNotFound: Boolean = false;
  productList: any = [];
  tagFilterData = [];
  defaultUrl = "assets/images/defaultimg.jpeg";
  products: any;
  auth: any;
  isShown: Boolean = false;
  pageNumber = 1;
  displayCategoryList: any;
  loadData;
  totalPages: any;
  varianceArray: any;
  searchProduct: any;
  searchOn: boolean;
  errorMsg: any;
  selectedStoreId: string;
  brandsList: any;
  speciesList: any;
  tagsList = [];
  specieCategory: any;
  brandCategory: any;
  tagCategory: any;
  weightList: any;
  weightCategory: any;
  subCategoryName: any;
  subCategoryId: any;
  selectedThcMin: any;
  selectedThcMax: any;
  pageNumforSearch = 1;
  totalSearchpages: any;
  scroll: boolean = false;
  cartProduct;
  showShimmer;
  showVariance;
  CartBarLimit: any = 0;
  CartBarLimitFlower: any = 0;
  varqtyvalue;
  canLoadFilterData;
  searchisin_process: Boolean = false;
  storeType = localStorage.getItem("isPickUpOrder");
  distance = 300;
  sc;
  index = 1;
  CategoryId;
  isPrerolls: boolean = false;
  finalqty: any;
  qty;
  marqueeText: any = [];
  @Input() payLoad: any;
  @HostListener("window:scroll", ["$event"])
  scrollHandler(event) {
    if (!this.appStateSvc.stateData.scroll) {
      return;
    }
    this.appStateSvc.stateData.resPerPage = 50;
    if (
      this.loadData &&
      !this.searchProduct &&
      this.appStateSvc.stateData.page <=
        this.appStateSvc.stateData.totalPages &&
      this.appStateSvc.stateData.totalPages != 1
    ) {
      this.loadData = true;

      let data: any = this.activatedRoute.params.subscribe((res) => {
        if (!res?.search) {
          if (res.categoryName == "NewArrivals") {
            this.categoryName = "New Arrivals";
          } else if (this.appStateSvc.stateData.totalPages == this.pageNumber) {
            this.productWithFilterListWithpagination();
            return;
          } else {
            this.productWithFilterListWithpagination();
          }
        }
      });
      data.unsubscribe();
    }

    if (
      this.loadData &&
      this.searchProduct &&
      this.pageNumforSearch < this.totalSearchpages
    ) {
      this.pageNumforSearch = this.pageNumforSearch + 1;
      this.productList = [];
      let obj = {
        storeId: Number(localStorage.getItem("localStoreId")),
        searchKey: this.searchProduct,
        resPerPage: 100,
        page: this.pageNumforSearch,
      };
      this.showShimmer = true;
      this.commonService.searchSingleProductnew(obj).subscribe((data: any) => {
        let a = data.data;
        this.showShimmer = false;

        this.setFilterData(data);
        this.productList = this.productList.concat(a);
      });
    }
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userSrv: UserService,
    private _bs: BehaviorService,
    private commonService: CommonService,
    private ls: LoaderModalService,
    private cartLengthService: CartlengthService,
    private appStateSvc: AppStateService,
    private _dataLayerService: DataLayerServiceService,
  ) {
    if (!localStorage.getItem("localStoreId")) {
      localStorage.setItem("localStoreId", "349669");
    }
    this.activatedRoute.data.subscribe(({ data }) => {
      let Category = data?.data;
      if (Category) {
        this.commonService.updateMetaKeywords(
          Category?.metaTitle ? Category?.metaTitle : Category?.title,
          Category?.metaKeywords ? Category?.metaKeywords : Category?.keywords,
          Category?.metaDescription
            ? Category?.metaDescription
            : Category?.description,
        );
      }
    });

    this.brandsList = this.appStateSvc.stateData.brandsList;
    this.speciesList = this.appStateSvc.stateData.speciesList;
    this.weightList = this.appStateSvc.stateData.weightList;
    this.tagsList = this.appStateSvc.stateData.tagsList;
  }

  ngOnInit(): void {
    this.productLists();
    window.addEventListener("scroll", this.scrolling, true);
    this.qtyValue = 1;
    this.varqtyvalue = 0;
    this.canLoadFilterData = false;

    $(window).on("scroll", function () {
      let top = $(window).scrollTop();
      if (top >= 100) {
        $("#breadcrumb-sticky").addClass("stickyShop");
      } else {
        $("#breadcrumb-sticky").removeClass("stickyShop");
      }
    });

    this.userSrv.getAuth().subscribe((res) => {
      if (res) {
        this.auth = true;
      } else {
        this.auth = false;
      }
    });
    this.checkValueInSearch();
    this.CartBarLimit = Number(localStorage.getItem("CartBarLimit"));
    this.CartBarLimitFlower = Number(
      localStorage.getItem("CartBarLimitFlower"),
    );
    this.selectedStoreId = localStorage.getItem("localStoreId");

    this.showVariance = false;
    this.searchOn = false;
    this.loadData = true;
    this.productList = [];

    this._bs.getSearch().subscribe((res) => {
      if (res != null && res != undefined) {
        if (res) {
          this.searchisin_process = true;
          let obj = {
            storeId: Number(localStorage.getItem("localStoreId")),
            searchKey: res,
            resPerPage: 200,
            page: 1,
          };
          this.searchInput = "";
          this.productList = [];
          this.showShimmer = true;
          this.pageNumforSearch = 1;
          this.commonService
            .searchSingleProductnew(obj)
            .subscribe((data: any) => {
              this._bs.setSearch("");
              this.setFilterData(data);
              this.searchProduct = "";
              this.showShimmer = false;
              this.totalSearchpages = data.pages;
              this.searchisin_process = false;
              setTimeout(() => {
                this.searchisin_process = false;
              }, 2000);
              this.searchOn = true;
              this.totalcount = data["count"];
              this.productList = data["data"];
              this.showShimmer = false;
            });
        }
      }
    });

    this.productList = [];
    this.getCategoryLists();

    this.userSrv.getAuth().subscribe((res) => {
      if (res) {
        this.auth = res;
      }
    });
    this.userSrv.getCartMessage().subscribe((res) => {
      if (res !== "") {
        $("#leftBarMenu").addClass("leftBarMenu");
      } else {
        $("#leftBarMenu").removeClass("leftBarMenu");
      }
    });
  }

  productLists() {
    this.loader2 = true;
    this.commonService
      .productWithFilter(this.payLoad)
      .subscribe((data: any) => {
        this.loader2 = false;
        if (data?.meta?.status) {
          this.productListing = data["data"];
        }
      });
  }

  scrolling = (s) => {
    let sc = s.target?.scrollingElement?.scrollTop;
    this.sc = sc;
    if (this.sc <= 100) {
      this.distance = 300;
      this.index = 1;
    } else {
      this.distance = this.distance;
    }
    if (sc >= this.distance) {
      this.appStateSvc.stateData.scroll = true;
      this.index = this.index + 1;
      this.distance = 300 * this.index;
    } else {
      this.appStateSvc.stateData.scroll = false;
    }
  };

  getBackGroundColor(tag) {
    if (tag) {
      return tag.tagColor;
    } else {
      return "#FFFFFF";
    }
  }

  hoverindex;
  setshophoverindex(index) {
    this.hoverindex = index;
  }
  setemptyHoverValue(i) {
    this.hoverindex = -1;
  }

  checkThc(min, max) {
    if (min == 0 && max == 0) {
      return false;
    }
    if (min < max) {
      return true;
    } else if (min == max && max > 0) {
      return true;
    } else {
      return false;
    }
  }
  thcType(type) {
    if (type == 0 || type == null || type == undefined) {
      return "%";
    } else {
      return type;
    }
  }

  checkZero(value: any) {
    if (value == 0 || value == null || value == undefined) {
      return false;
    } else {
      return true;
    }
  }

  getBackGroundColorAccToSpecies(name) {
    return "#f8f8f8";
  }
  getFullName(item: any) {
    if (item != undefined && item != null) {
      return item?.split("")[0];
    }
  }

  defaultBackground = "assets/images/footer-bg.jpg";
  getBackGroundImg(img) {
    let index;
    if (img) {
      index = img.findIndex(function (item) {
        return item?.bannerFor == "DESKTOP";
      });
    }
    if (index != undefined && index != -1) {
      if (img[index]?.bannerFor == "DESKTOP") return img[index]?.bannerImg;
      else {
        return this.defaultBackground;
      }
    } else {
      return this.defaultBackground;
    }
  }

  productUnder: number = 0;

  increaseDecreaseOfflineProduct(productId, data, list) {
    if (data?.finalqty == undefined || data?.finalqty == 0) {
      return;
    }
    let images = "";
    if (data["productDetails"].HeroShotUri !== null) {
      images = data["productDetails"].HeroShotUri;
    } else {
      images = this.defaultUrl;
    }
    if (this.auth) {
      this.addToCartvar(data["productDetails"], false, images);
    } else {
      let currentcProd = JSON.parse(localStorage.getItem("cartProduct"));
      let objIndex = currentcProd["product"].findIndex(
        (obj) => obj?.productId == productId,
      );
      currentcProd["product"][objIndex]["buyPrice"] =
        currentcProd["product"][objIndex]["buyPrice"];
      currentcProd["product"][objIndex]["actualQuantity"] =
        currentcProd["product"][objIndex]["actualQuantity"];
      currentcProd["product"][objIndex]["myPrice"] =
        currentcProd["product"][objIndex]["myPrice"];
      currentcProd["product"][objIndex]["price"] =
        currentcProd["product"][objIndex]["price"];
      currentcProd["product"][objIndex]["productDisplayId"] =
        currentcProd["product"][objIndex]["productDisplayId"];
      currentcProd["product"][objIndex]["productId"] =
        currentcProd["product"][objIndex]["productId"];
      currentcProd["product"][objIndex]["productImg"] =
        currentcProd["product"][objIndex]["productImg"];
      currentcProd["product"][objIndex]["productName"] =
        currentcProd["product"][objIndex]["productName"];
      currentcProd["product"][objIndex]["productType"] =
        currentcProd["product"][objIndex]["productType"];
      currentcProd["product"][objIndex]["productslug"] =
        currentcProd["product"][objIndex]["productslug"];
      currentcProd["product"][objIndex]["purchaseStatus"] =
        currentcProd["product"][objIndex]["purchaseStatus"];
      currentcProd["product"][objIndex]["quantity"] =
        currentcProd["product"][objIndex]["quantity"] - 1;
      currentcProd["product"][objIndex]["storeId"] =
        currentcProd["product"][objIndex]["storeId"];
      currentcProd["product"][objIndex]["weight"] =
        currentcProd["product"][objIndex]["weight"];
      currentcProd["product"][objIndex]["categoryId"] =
        this._bs.fetchCategoryId(list?.category);
      localStorage.setItem("cartProduct", JSON.stringify(currentcProd));
      this.commonService.go_invokeCartResetFunction_forguest();

      this.increaseValues(
        currentcProd,
        productId,
        currentcProd[objIndex]?.quantity,
      );
    }
  }

  finalQuantity: number = 0;
  dummyArr = [];
  increaseValues(array?, id?, qty?) {
    let changevarArr = this.varianceArray;
    if (qty == 0) {
      window.location.reload();
    }
    if (this.auth) {
      for (let i = 0; i <= array?.length; i++) {
        changevarArr?.map((e) => {
          if (array[i]?.inventoryId == e?.CatalogItemId) {
            e["finalqty"] = qty;
          }
        });
        this.varianceArray = changevarArr;
      }
    } else {
      let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
      let arrayodproducts = currentcartProd["product"];
      if (changevarArr == undefined) {
        changevarArr = [];
      }
      for (let i = 0; i <= arrayodproducts?.length; i++) {
        changevarArr?.map((e) => {
          if (arrayodproducts[i]?.productId == e?.CatalogItemId) {
            e["finalqty"] = arrayodproducts[i]?.quantity;
          }
        });
      }
    }

    return this.varianceArray;
  }

  VARID;
  PREVIOUSVARID;
  HandleVarinceAddToCartOrNot(data, index) {
    if (!this.PREVIOUSVARID) {
      this.VARID = data._id;
      this.PREVIOUSVARID = data._id;
    } else {
      if (this.PREVIOUSVARID != data._id) {
        this.varqtyvalue = 0;
        this.VARID = data._id;
        this.PREVIOUSVARID = data._id;
      }
    }
  }

  resetFilter() {
    this.specieCategory = "";
    this.brandCategory = "";
    this.tagCategory = "";
    this.weightCategory = "";
    this.showShimmer = false;
    this.selectedThcMin = 0;
    this.selectedThcMax = 0;
    this.subCategoryId = "";
    this.subCategoryName = "";
    this.canLoadFilterData = false;
    this.show_sale_red_flag = false;
    this.appStateSvc.setState({
      page: 1,
      productData: [],
      productcount: 0,
    });
    this.pageNumber = 1;
    this.productList = [];
  }

  setFilterData(filterData) {
    this.brandsList = filterData?.BrandList;
    this.speciesList = filterData?.SpeciesList;
    this.weightList = filterData?.WeightList;
    this.tagsList = filterData?.tagList;
    this.appStateSvc.setState({
      brandsList: this.brandsList,
      speciesList: this.speciesList,
      weightList: this.weightList,
      tagsList: this.tagsList,
    });
  }

  filterObj;
  selectedCbdMax;
  selectedCbdMin;
  show_sale_red_flag: Boolean = false;
  isNewArrivalselected: Boolean = false;
  specialsselected: Boolean = false;
  totalcount: number = 0;

  updateMetaTags(data) {
    let siteDada: any = JSON.parse(localStorage.getItem("siteData"));
    this.commonService.getSeoContent(data).subscribe((res) => {
      setTimeout(() => {
        this.commonService.updateMetaKeywords(
          res?.title ? res?.title : siteDada?.headertitle,
          res?.keywords ? res?.keywords : siteDada?.keywords,
          res?.description ? res?.description : siteDada?.headertitle,
        );
      }, 1000);
    });
  }

  productWithFilterListWithpagination() {
    this.loadData = false;
    this.showShimmer = true;
    const obj = {
      Brand: [],
      CBDMax: 0,
      CBDMin: 0,
      IsDeals: true,
      NetWeight: [],
      Species: [],
      THCMax: 0,
      THCMin: 0,
      pageNumber: 1,
      productUnder: 0,
      resPerPage: 15,
      storeId: "349669",
      tags: [],
    };
    this.commonService.productWithFilter(obj).subscribe((data: any) => {
      if (data?.meta?.status) {
        this.setFilterData(data);
        this.loadData = true;
        this.canLoadFilterData = true;
        const incoming: any[] = Array.isArray(data.data) ? data.data : [];
        const keyOf = (p: any) => p?.productId ?? p?.id ?? p?._id;
        const merged = [...this.productList, ...incoming];
        const map = new Map<any, any>();
        for (const item of merged) {
          const k = keyOf(item);
          if (k != null) {
            map.set(k, item);
          }
        }
        this.productList = Array.from(map.values());
        this.totalcount = data.count;
        this.appStateSvc.setState({
          productData: this.productList,
          productcount: this.totalcount,
          page: (data.currentPage ?? 0) + 1,
        });

        const extremerightfilterval = $("#extremerightfilter").val();
        this.sortnew(extremerightfilterval);

        this.showShimmer = false;
        this.appStateSvc.stateData.totalPages = data.pages;
      }
    });
  }

  redirectToDetailPage(slug: string) {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    this.appStateSvc.setState({
      scrollPosition: scrollPosition,
      scroll: true,
    });

    this.router.navigateByUrl(`/shop/product/${slug}`);
  }

  actualId;
  showDiv(item) {
    this.actualId = item;
    this.isShown = true;
  }

  showDiv1(item) {
    this.varqtyvalue = 0;
    this.actualId = item;
    this.isShown = false;
    this.VARID = "";
  }

  getImageSize(productImg) {
    return productImg;
  }

  getImageSize3(array) {
    if (array.length) {
      return array[0]["Uri"];
    } else {
      return this.defaultUrl;
    }
  }

  pickUpStatus;
  orderType;
  getOrderType() {
    this.pickUpStatus = localStorage.getItem("isPickUpOrder");
    if (this.pickUpStatus === "true") {
      this.orderType = "Pickup";
      return "Pickup";
    } else {
      this.orderType = "Delivery";
      return "Delivery";
    }
  }

  openModal(val) {
    if (val == 1) {
      $("#SearchLocation").modal("hide");
    }
    if (val == 0) {
      $("#SearchLocation").modal("show");
    }
  }

  checkValueInSearch() {
    this.activatedRoute.queryParams.subscribe((res) => {
      this.searchInput = res["search"];
    });
  }
  searchProductFilter(value) {
    if (value === "") {
      this.router.navigateByUrl(`/shop/all`);
    } else {
      let d1 = value?.replaceAll(/ /g, " ");
      this.router.navigateByUrl(`/shop/all?search=${d1}`);
    }
  }

  out() {
    this.searchIn = false;
    this.showNoResult = false;
  }

  @HostListener("document:click", ["$event"]) onDocumentClick(event) {
    this.searchIn = false;
    this.showNoResult = false;
  }
  searchInput = "";
  searchIn: boolean = false;
  showNoResult: boolean = false;
  search_suggestionArr;
  searchSuggest1(event) {
    event.stopPropagation();
    let searchValue = event.target.value;
    this.showNoResult = false;

    if (searchValue.length == 0) {
      this.searchIn = false;
      this.showNoResult = false;
      return (this.search_suggestionArr = []);
    }
    if (searchValue.length > 2) {
      let obj = {
        storeId: Number(localStorage.getItem("localStoreId")),
        searchKey: searchValue,
        resPerPage: 10,
        page: 1,
      };

      this.commonService.searchSingleProductnew(obj).subscribe((res) => {
        if (res["data"]) {
          if (res["data"].length) {
            this.searchIn = true;
            this.showShimmer = false;
            this.setFilterData(res);
            this.search_suggestionArr = res["data"];
          } else {
            this.search_suggestionArr = [];
            this.showNoResult = true;
            this.searchIn = false;
          }
        } else {
          this.showNoResult = true;
          this.searchIn = false;
          this.search_suggestionArr = [];
        }
      });
    }
  }

  hideSearchDiv() {
    this.searchIn = false;
  }

  addSelectedVariance(productDetails) {
    if (!this.auth) {
      let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));

      let array = currentcartProd?.product.filter(
        (product) => product?.productId == productDetails?.CatalogItemId,
      );
      if (array?.length == 0) {
        this.addToCart(productDetails);
      } else {
        array?.forEach((itm: any, i) => {
          if (itm?.productId == productDetails?.CatalogItemId) {
            if (itm?.quantity < productDetails?.Quantity) {
              this.addToCart(productDetails);
            } else {
              this.ls.startLoader("", "");
              this.ls.changeStateandStopLoader(
                "error",
                `Maximum quantity of this product is ${productDetails?.Quantity}`,
                2000,
              );
            }
          }
        });
        if (currentcartProd == undefined) {
          this.addToCart(productDetails);
        }
      }
    } else {
      this.addToCart(productDetails);
    }
  }

  offlineWeightCheck(productDetails, value, list) {
    let flowerLimit: any = localStorage.getItem("CartBarLimitFlower");
    let otherLimit: any = localStorage.getItem("CartBarLimit");
    let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
    if (
      currentcartProd &&
      currentcartProd["product"] &&
      currentcartProd["product"]?.length
    ) {
      if (
        this._bs.fetchCategoryId(list?.category) == 2543 &&
        this._bs.fetchCategoryId(list?.category) != 2542
      ) {
        let flowerProducts: any = currentcartProd["product"]?.filter(
          (itm) => itm?.categoryId == 2543,
        );
        let floweWeight: any = 0;
        flowerProducts?.forEach((element) => {
          floweWeight += element?.equivalentToVal * element?.quantity;
        });
        if (
          Number(floweWeight) +
            Number(productDetails?.productDetails?.EquivalentToVal) >
          flowerLimit
        ) {
          $("#cartLimitModalFlower").modal("show");
          setTimeout(() => {
            $("#cartLimitModalFlower").modal("hide");
          }, 1500);
          return;
        } else {
          this.addOfflineProductInCart(productDetails, value, list);
        }
      }

      if (
        this._bs.fetchCategoryId(list?.category) != 2543 &&
        this._bs.fetchCategoryId(list?.category) != 2542
      ) {
        let otherProducts: any = currentcartProd["product"]?.filter(
          (itm) => itm?.categoryId != 2543,
        );

        let otherWeight: any = 0;
        otherProducts?.forEach((element) => {
          otherWeight += element?.equivalentToVal * element?.quantity;
        });
        if (
          Number(otherWeight) +
            Number(productDetails?.productDetails?.EquivalentToVal) >
          otherLimit
        ) {
          $("#cartLimitModal").modal("show");
          setTimeout(() => {
            $("#cartLimitModal").modal("hide");
          }, 1500);
          return;
        } else {
          this.addOfflineProductInCart(productDetails, value, list);
        }
      }
    } else {
      this.addOfflineProductInCart(productDetails, value, list);
    }
  }

  addToCart(productDetails) {
    localStorage.setItem("categoryId", JSON.stringify(productDetails.category));
    const addressStatus = localStorage.getItem("addressStatus");
    if (addressStatus === null || addressStatus === "false") {
      $("#SearchLocation").modal("show");
    } else if (!this.auth) {
      this.offlineWeightCheck(productDetails, false, productDetails);
    } else {
      let limit = localStorage.getItem("cartLimit");
      let limitFlower = localStorage.getItem("cartLimitFlower");

      this.ls.startLoader("", "");
      let obj = {
        inventoryId: productDetails.CatalogItemId,
        selectQuantity: this.qtyValue,
        storeId: Number(localStorage.getItem("localStoreId")),
        orderType: this.getOrderType(),
        productId: productDetails.CatalogItemId,
        otherWtSum: limit,
        productslug: productDetails?.productslug,
        flowerWtSum: limitFlower,
        qtyIncrease: true,
        recommended: "NO",
        categoryId: this._bs.fetchCategoryId(productDetails?.category),
      };
      this.commonService.addProductInCartnew(obj).subscribe((res) => {
        if (res["meta"]["status"]) {
          let userCartLength = res["data"]["addtoCart"]
            ? res["data"]["addtoCart"].length
            : 0;
          this.cartLengthService.cartLengthUpdateFunction(userCartLength);
          this._dataLayerService.addToCartGTM(res["data"]["addtoCart"]);
          this.ls.changeStateandStopLoader("success", "Added to Cart", 1000);
        } else {
          this.errorMsg = res["meta"]["msg"];

          if (
            this.errorMsg ===
            "Store must be unique ! Please try again with same store"
          ) {
            $("#exampleModal").modal("show");
            this.ls.stopLoader();
          } else if (
            this.errorMsg ==
            `You can not add products more than ${this.CartBarLimit}g`
          ) {
            $("#cartLimitModal").modal("show");
            this.ls.stopLoader();
          } else if (
            this.errorMsg ==
            `You can not add products more than ${this.CartBarLimitFlower}g`
          ) {
            $("#cartLimitModalFlower").modal("show");
            this.ls.stopLoader();
          } else {
            this.ls.changeStateandStopLoader("error", res["meta"]["msg"], 3000);
          }
        }
      });
    }
  }
  quantity: any = 0;

  addToCartvar(productDetails, boolean, list?) {
    if (!this.auth) {
      this.offlineWeightCheck(productDetails, false, list);
    } else {
      this.quantity = this.quantity + 1;
      if (this.quantity > 1) {
        return;
      }

      let limit = localStorage.getItem("cartLimit");
      let limitFlower = localStorage.getItem("cartLimitFlower");

      let obj = {};

      if (!boolean) {
        this.ls.startLoader("", "");
        obj = {
          inventoryId: productDetails.CatalogItemId,
          selectQuantity: 1,
          storeId: Number(localStorage.getItem("localStoreId")),
          orderType: this.getOrderType(),
          productId: productDetails.CatalogItemId,
          otherWtSum: limit,
          flowerWtSum: limitFlower,
          qtyIncrease: false,
          categoryId: this._bs.fetchCategoryId(list?.category),
        };
      } else {
        this.ls.startLoader("", "");
        obj = {
          inventoryId: productDetails.CatalogItemId,
          selectQuantity: 1,
          storeId: Number(localStorage.getItem("localStoreId")),
          orderType: this.getOrderType(),
          productId: productDetails.CatalogItemId,
          otherWtSum: limit,
          flowerWtSum: limitFlower,
          qtyIncrease: true,
          recommended: "NO",
          categoryId: this._bs.fetchCategoryId(list?.category),
        };
      }
      this.commonService.addProductInCartnew(obj).subscribe((res) => {
        this.quantity = 0;

        this.ls.changeStateandStopLoader("success", "Added to Cart", 1000);

        if (res["meta"]["status"]) {
          let userCartLength = res["data"]["addtoCart"]
            ? res["data"]["addtoCart"].length
            : 0;

          this.cartLengthService.cartLengthUpdateFunction(userCartLength);
          this._dataLayerService.addToCartGTM(res["data"]["addtoCart"]);
          if (boolean) {
            this.varqtyvalue = this.varqtyvalue + 1;
          } else {
            this.varqtyvalue = this.varqtyvalue - 1;
          }
          this.ls.changeStateandStopLoader("success", "Added to Cart", 1000);
          this.increaseValues(res["data"]["addtoCart"], "", this.varqtyvalue);
        } else {
          this.errorMsg = res["meta"]["msg"];

          if (
            this.errorMsg ===
            "Store must be unique ! Please try again with same store"
          ) {
            $("#exampleModal").modal("show");
            this.ls.stopLoader();
          } else if (
            this.errorMsg ==
            `You can not add products more than ${this.CartBarLimit}g`
          ) {
            this.ls.stopLoader();
          } else if (
            this.errorMsg ==
            `You can not add products more than ${this.CartBarLimitFlower}g`
          ) {
            this.ls.stopLoader();
          } else {
            this.ls.changeStateandStopLoader("error", res["meta"]["msg"], 3000);
          }
        }
      });
    }
  }

  getToFixedValue(value) {
    return Number(value).toFixed(2);
  }

  letNewArray: Array<any> = [];
  imageDetails;
  addOfflineProductInCart(productDetails, boolean?, list?) {
    this.ls.startLoader("", "");
    let image;
    let productName = "";
    this.imageDetails = productDetails["productDetails"].Assets;

    if (this.imageDetails !== undefined && this.imageDetails?.length > 0) {
      if (
        this.imageDetails[0]?.Uri !== null &&
        this.imageDetails[0]?.Uri !== ""
      ) {
        image = this.imageDetails[0]?.Uri;
      } else {
        image = this.defaultUrl;
      }
    } else {
      image = this.defaultUrl;
    }
    if (list != undefined && list !== null) {
      this.imageDetails = list["productDetails"].Assets;
      productName = productDetails["productDetails"]?.ProductName;
      if (this.imageDetails !== undefined && this.imageDetails?.length > 0) {
        if (
          this.imageDetails[0]?.Uri !== null &&
          this.imageDetails[0]?.Uri !== ""
        ) {
          image = this.imageDetails[0]?.Uri;
        } else {
          image = this.defaultUrl;
        }
      } else {
        image = this.defaultUrl;
      }
    } else {
      productName = productDetails["productDetails"]?.ProductName;
    }
    if (boolean) {
      this.qty = this.varqtyvalue++;
    }
    var hasMatch = false;
    let array = JSON.parse(localStorage.getItem("cartProduct"));
    this.letNewArray.push(array);
    let productArray = [];
    let cartProductArrayWithStore;
    if (localStorage.getItem("cartProduct") === null || array?.length === 0) {
      this.varqtyvalue = 1;
      cartProductArrayWithStore = {
        storeId: localStorage.getItem("localStoreId"),
      };
      productArray.push({
        productId: productDetails?.CatalogItemId,
        productType: "simple",
        myPrice: productDetails?.myPrice,
        inventoryType: productDetails?.inventoryType,
        storeId: localStorage.getItem("localStoreId"),
        quantity: 1,
        productslug: productDetails?.productslug,
        weight: productDetails?.productDetails
          ? productDetails?.productDetails?.EquivalentToVal
          : 0,
        productName: productName,
        actualQuantity: productDetails?.Quantity,
        productImg: image ? image : this.defaultUrl,
        price: productDetails?.price,
        buyPrice: productDetails?.Msrp,
        purchaseStatus: "purchase",
        productDisplayId: productDetails?.CatalogItemId,
        equivalentToVal: productDetails?.productDetails
          ? productDetails?.productDetails?.EquivalentToVal
          : 0,
        require: "Require",
        selectQuantity: 1,
        productTitle: productName,
        categoryId: this._bs.fetchCategoryId(list?.category),
        withoutDiscountPrice: productDetails?.price,
      });

      this.letNewArray = productArray;

      cartProductArrayWithStore["product"] = productArray;
      localStorage.setItem(
        "cartProduct",
        JSON.stringify(cartProductArrayWithStore),
      );
      this.ls.changeStateandStopLoader("success", "Added to Cart", 2000);
      this.commonService.emittedCartValue.next(true);
      this.commonService.go_invokeCartResetFunction_forguest();
    } else {
      let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
      let currentcartWeight = 0;
      currentcartProd["product"].forEach((cartPd) => {
        currentcartWeight =
          currentcartWeight + cartPd?.weight * cartPd?.quantity;
      });
      this.CartBarLimit = localStorage.getItem("CartBarLimit");

      let productArrayData = JSON.parse(localStorage.getItem("cartProduct"));
      productArray = productArrayData["product"];
      if (
        productArrayData["storeId"] === localStorage.getItem("localStoreId")
      ) {
        for (var i = 0; i < productArray.length; i++) {
          if (productArray[i].productId === productDetails.CatalogItemId) {
            this.varqtyvalue = 1;
            let removedata = productArray.splice(i, 1);
            productArray.push({
              productId: productDetails?.CatalogItemId,
              productType: "simple",
              myPrice: productDetails?.myPrice,
              productslug: productDetails?.productslug,
              actualQuantity: productDetails?.Quantity,
              inventoryType: productDetails.inventoryType,
              storeId: localStorage.getItem("localStoreId"),
              quantity: Number(removedata[0]["quantity"]) + 1,
              weight: productDetails?.productDetails
                ? productDetails?.productDetails?.EquivalentToVal
                : 0,
              productName: productName,
              productImg: image,
              price: productDetails.price,
              buyPrice: productDetails.Msrp,
              purchaseStatus: "purchase",
              productDisplayId: productDetails.CatalogItemId,
              equivalentToVal: productDetails?.productDetails
                ? productDetails?.productDetails?.EquivalentToVal
                : 0,
              require: "Require",
              selectQuantity: Number(removedata[0]["quantity"]) + 1,
              productTitle: productName,
              categoryId: this._bs.fetchCategoryId(list?.category),
              withoutDiscountPrice: productDetails.price,
            });

            localStorage.setItem(
              "cartProduct",
              JSON.stringify(productArrayData),
            );
            this.ls.changeStateandStopLoader("success", "Added to Cart", 3000);
            this.commonService.emittedCartValue.next(true);
            this.commonService.go_invokeCartResetFunction_forguest();
            hasMatch = true;
            break;
          }
        }
      } else {
        this.ls.changeStateandStopLoader(
          "error",
          "Clear cart first then add product",
          3000,
        );
      }
      if (!hasMatch) {
        this.varqtyvalue = 1;
        productArray.push({
          productId: productDetails.CatalogItemId,
          productType: "simple",
          myPrice: productDetails?.myPrice,
          inventoryType: productDetails.inventoryType,
          storeId: localStorage.getItem("localStoreId"),
          quantity: this.qtyValue,
          weight: productDetails.productDetails.EquivalentToVal
            ? productDetails.productDetails.EquivalentToVal
            : 0,
          productName: productName,
          productslug: productDetails?.productslug,
          actualQuantity: productDetails?.Quantity,
          productImg: image,
          price: productDetails.price,
          buyPrice: productDetails.Msrp,
          purchaseStatus: "purchase",
          productDisplayId: productDetails.CatalogItemId,
          equivalentToVal: productDetails.productDetails.EquivalentToVal
            ? productDetails.productDetails.EquivalentToVal
            : 0,
          require: "Require",
          selectQuantity: this.qtyValue,
          productTitle: productName,
          categoryId: this._bs.fetchCategoryId(list?.category),
          withoutDiscountPrice: productDetails.price,
        });

        let cartProductArrayWithStore = {
          storeId: localStorage.getItem("localStoreId"),
          product: productArray,
        };

        localStorage.setItem(
          "cartProduct",
          JSON.stringify(cartProductArrayWithStore),
        );
        this.ls.changeStateandStopLoader("success", "Added to Cart", 2000);
        this.commonService.emittedCartValue.next(true);
        this.commonService.go_invokeCartResetFunction_forguest(); 
      }
    }
    this._dataLayerService.addToCartGTMGuest(productArray);
    this.letNewArray = productArray;
    this.increaseValues(
      this.letNewArray,
      productDetails.CatalogItemId,
      this.letNewArray[0].quantity,
    );
    this.commonService.updateCartProduct(productArray.length);
  }

  cartLength = 0;

  removeProductFromOfflineCart(productId, productDetails) {
    if (!this.auth) {
      let offlineData = [];
      offlineData = JSON.parse(localStorage.getItem("cartProduct"));
      offlineData["product"].map((x, i) => {
        if (productDetails.productType === "simple") {
          if (x.productId === productId) {
            let data: any = offlineData["product"].filter(
              (itm) => itm?.productId != productDetails?.CatalogItemId,
            );
            let itm: any = {};
            itm["product"] = data;
            localStorage.setItem("cartProduct", JSON.stringify(itm));
            this.cartLength = itm["product"].length;
            if (!this.cartLength) {
              this.cartLengthService.cartLengthUpdateFunction(0);
              this.ngOnInit();
            } else {
              this.cartLengthService.cartLengthUpdateFunction(this.cartLength);
              this.ngOnInit();
            }
          }
        } else {
          if (x.productId === productDetails?.CatalogItemId) {
            let data: any = offlineData["product"].filter(
              (itm) => itm?.productId != productDetails?.CatalogItemId,
            );
            let itm: any = {};
            itm["product"] = data;

            localStorage.setItem("cartProduct", JSON.stringify(itm));
            this.cartLength = itm["product"]?.length;
            this.commonService.emittedCartValue.next(true);
            this.commonService.updateCartProduct(itm["product"]?.length);
          }
        }
      });
    } else {
      this.getonlinedata();
    }

    let varArr = this.varianceArray;
    for (let i = 0; i <= varArr.length; i++) {
      varArr.map((e) => {
        if (productDetails.CatalogItemId == e.CatalogItemId) {
          e["finalqty"] = 0;
        }
      });
      this.varianceArray = varArr;
    }
  }
  myonlinecarts = [];
  getonlinedata() {
    var isSwitchStatus = "false";
    var storeID = localStorage.getItem("localStoreId");

    isSwitchStatus = localStorage.getItem("isSwitch");
    this.ls.startLoader("", "");
    this.commonService.getUserCartProduct(isSwitchStatus, storeID).subscribe(
      (res: any) => {
        if (res["data"] && res["data"]["addtoCart"]) {
          this.varqtyvalue = 0;

          this.myonlinecarts = res["data"]["addtoCart"];
          this.onlineremoveProduct(this.myonlinecarts[0]?._id, "");
        }
      },
      (error) => {
        this.ls.changeStateandStopLoader("error", error.msg, 1000);
      },
    );
  }
  onlineremoveProduct(subProductId, productId) {
    let obj = {
      productSubId: subProductId,
      productId: productId,
    };
    this.ls.startLoader("", "");
    this.commonService.removeProductFromCart(obj).subscribe((res) => {
      if (res["meta"]["status"]) {
        this._bs.setCart("remove");

        this.commonService.updateCartProduct(0);
        this.ls.changeStateandStopLoader("success", "Remove from Cart", 1000);
        let userCartLength = res["data"]["addtoCart"]
          ? res["data"]["addtoCart"]?.length
          : 0;
        this.cartLengthService.cartLengthUpdateFunction(userCartLength);
      } else {
        this.ls.stopLoader();

        if (res["meta"]["msg"] == "No Product found in your cart.") {
          this.cartLengthService.cartLengthUpdateFunction(0);
          this.commonService.updateCartProduct(0);
        }
      }
    });
  }

  categoryList;
  getCategoryLists() {
    this.commonService.getCategoryList().pipe(
      tap((res) => {
        this.categoryList = res["data"];
        if (this.subCategoryName) {
          let categoryObj;
          this.categoryList.forEach((a) => {
            if (a.subCategory.length > 0) {
              a.subCategory.forEach((b) => {
                if (b.subCategoryName == this.subCategoryName) {
                  return (categoryObj = a);
                }
              });
            }
          });

          this.filterSubCategoryList = categoryObj.subCategory;
          this.filterSubCategoryList = this.filterSubCategoryList.sort(
            (a, b) => {
              const nameA = a.subCategoryName.toUpperCase().trim(); 
              const nameB = b.subCategoryName.toUpperCase().trim(); 
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            },
          );
          this.categoryName = categoryObj.categoryName;
        }
      }),
    );
  }

  pushingCategoryFunc(category) {
    this.displayCategoryList.push(category);
  }

  filterSubCategoryList;

  sort(key, status, text) {
    this.sortingType = status;
    this.sortingElement = key;
    this.filterText = text;
    window.scrollTo(50, 100);
  }
  redirectToShopPage1() {
    this.categoryName = "all";
    let categoryNameWithId = "all";
    this.router.navigateByUrl("/shop/all");
    this.userSrv.updateShopLink(categoryNameWithId);
  }

  sortnew(value) {
    if (value == "select") {
      let a = $("#extremerightfilter2").val();
      this.sortmobile(a);
    }

    if (value == "thcltoh") {
      let a = this.productList.sort((a, b) => {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
        return a.productDetails.THCMax - b.productDetails.THCMax;
      });
    }

    if (value == "thchtol") {
      let a = this.productList.sort(
        (a, b) => b.productDetails.THCMax - a.productDetails.THCMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == "cbdltoh") {
      this.productList.map((e) => {
        if (e.productDetails.CbdType == "") {
          e.productDetails.CbdType = "%";
        }
      });
      let a = this.productList.sort(
        (a, b) => a.productDetails.CBDMax - b.productDetails.CBDMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == "cbdhtol") {
      let a = this.productList.sort(
        (a, b) => b.productDetails.CBDMax - a.productDetails.CBDMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == "thcLow") {
      let a = this.productList.sort(
        (a, b) => a.productDetails.THCMax - b.productDetails.THCMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }
    if (value == "thcHigh") {
      let a = this.productList.sort(
        (a, b) => b.productDetails.THCMax - a.productDetails.THCMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == 12) {
      let a = this.productList.sort((a, b) => a.price - b.price);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == 24) {
      let a = this.productList.sort((a, b) => b.price - a.price);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }
    if (value == "atoz") {
      let a = this.productList.sort((a, b) => {
        const nameA = a.productDetails.ProductName.toUpperCase().trim(); 
        const nameB = b.productDetails.ProductName.toUpperCase().trim(); 
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == "ztoa") {
      let a = this.productList.sort((a, b) => {
        const nameA = a.productDetails.ProductName.toUpperCase().trim(); 
        const nameB = b.productDetails.ProductName.toUpperCase().trim(); 
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
        return 0;
      });
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }
    this.showShimmer = false;
  }
  sortmobile(value) {
    if (value == "cbdltoh") {
      this.productList.map((e) => {
        if (e.productDetails.CbdType == "") {
          e.productDetails.CbdType = "%";
        }
      });
      let a = this.productList.sort(
        (a, b) => a.productDetails.CBDMax - b.productDetails.CBDMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == "cbdhtol") {
      let a = this.productList.sort(
        (a, b) => b.productDetails.CBDMax - a.productDetails.CBDMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == "thcLow") {
      let a = this.productList.sort(
        (a, b) => a.productDetails.THCMax - b.productDetails.THCMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }
    if (value == "thcHigh") {
      let a = this.productList.sort(
        (a, b) => b.productDetails.THCMax - a.productDetails.THCMax,
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      return (this.productList = a);
    }

    if (value == 12) {
      let a = this.productList.sort((a, b) => a.price - b.price);
      return (this.productList = a);
    }

    if (value == 24) {
      let a = this.productList.sort((a, b) => b.price - a.price);
      return (this.productList = a);
    }
    if (value == "atoz") {
      let a = this.productList.sort((a, b) => {
        const nameA = a.productDetails.ProductName.toUpperCase().trim(); 
        const nameB = b.productDetails.ProductName.toUpperCase().trim(); 
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      return (this.productList = a);
    }

    if (value == "ztoa") {
      let a = this.productList.sort((a, b) => {
        const nameA = a.productDetails.ProductName.toUpperCase().trim(); 
        const nameB = b.productDetails.ProductName.toUpperCase().trim(); 
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
        return 0;
      });
      return (this.productList = a);
    }
    this.showShimmer = false;
  }

  sortDataAccordingToFilter(key, status, text) {
    this.sortingType = status;
    this.sortingElement = key;
    this.filterText = text;
    window.scrollTo(50, 100);
  }

  changePage(event) {
    this.pageNumber = event;
  }

  showVariance_isDuplicate = false;
  showVarianceList(array, id, boolean) {
    this.actualId = id;
    this.isShown = true; 
    this.varianceArray = array;
    this.varianceArray.map((e) => {
      e["finalqty"] = 0;
    });
    this.showVariance = true;
    this.showVariance_isDuplicate = boolean;
  }

  getBrandName(data) {
    let brandObj = data.productDetails.brand;
    let name =
      brandObj["brandName"] != "" ? brandObj["brandName"] : "BRAND NAME";
    return name;
  }

  closeOthers(openDetails) {}
  isFilterTage = false;
  isAdd = "+";
  closeTags() {
    this.isFilterTage = !this.isFilterTage;
    if (this.isFilterTage) {
      this.isAdd = "-";
    } else {
      this.isAdd = "+";
    }
  }
}
